import Vue from "vue";
import FormGroup from "./FormGroup.vue";
import Modal from "./Modal.vue";
import PrintBtn from "./PrintBtn.vue";

Vue.component("FormGroup", FormGroup);
Vue.component("Modal", Modal);
Vue.component("PrintBtn", PrintBtn);



// WEBPACK FOOTER //
// ./src/components/comunes/index.js